module.exports = __webpack_public_path__ + "static/chatbotize-e1f31596a06828d8016d48a17e241847.png";